import { render } from "./Facebook.vue.ts?vue&type=template&id=a31ada3d&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Facebook.vue?vue&type=template&id=a31ada3d&ts=true"
import script from "./Facebook.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Facebook.vue?vue&type=script&lang=ts&setup=true"
export * from "./Facebook.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Facebook.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/components/Facebook.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a31ada3d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a31ada3d', __exports__)) {
    api.reload('a31ada3d', __exports__)
  }
  
  module.hot.accept("./Facebook.vue.ts?vue&type=template&id=a31ada3d&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Facebook.vue?vue&type=template&id=a31ada3d&ts=true", () => {
    api.rerender('a31ada3d', render)
  })

}


export default __exports__